import { FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import { DoorDirection } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { FieldStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

export const DoorDirectionFormControl = observer(
  ({ value, onChange }: { value: DoorDirection; onChange: () => void }) => {
    const { t } = useTranslate()

    return (
      <FormControl fullWidth>
        <InputLabel>{t('selectTheDoorDirection', 'Select the door direction')}</InputLabel>

        <Select
          label={t('selectTheDoorDirection', 'Select the door direction')}
          value={value}
          onChange={onChange}
        >
          <MenuItem value={DoorDirection.Anyway}>{t('anyway', 'Anyway')}</MenuItem>
          <MenuItem value={DoorDirection.Inward}>{t('inward', 'Inward')}</MenuItem>
          <MenuItem value={DoorDirection.Outward}>{t('outward', 'Outward')}</MenuItem>
        </Select>
      </FormControl>
    )
  },
)

export const DoorDirectionField: FC<{ doorDirection: FieldStore<DoorDirection> }> = observer(
  ({ doorDirection }) => {
    const { t } = useTranslate()

    return (
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid size={12}>
          <Typography variant='subtitle1'>{t('doorDirection', 'Door Direction')}</Typography>
        </Grid>
        <Grid size={12}>
          <DoorDirectionFormControl value={doorDirection.value} onChange={doorDirection.onChange} />
        </Grid>
      </Grid>
    )
  },
)
